<template>
    <v-dialog v-model="shows" width="1280" persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light v-bind="{ loading }">
            <v-card-title>
                {{ title }}
                <v-spacer />
                <v-btn icon tile @click="shows = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="py-5">
                <v-row class="ma-n2">
                    <v-col cols="12" md="8" class="pa-2">
                        <v-text-field v-model="form.path" label="경로" outlined dense hide-details persistent-placeholder v-bind="{ loading }" />
                    </v-col>
                    <v-col cols="12" md="4" class="pa-2">
                        <view-switch-section v-model="form.uses" title="사용여부" v-bind="{ loading }" />
                    </v-col>
                    <v-col cols="12" lg="8" class="pa-2">
                        <form-tags v-model="form.tags" @input="emit" />
                    </v-col>
                    <v-col cols="12" lg="4" class="pa-2">
                        <view-section-card title="미리보기" class="fill-height">
                            <v-textarea :value="form.code" readonly flat solo auto-grow rows="8" hide-details class="metatag-form__code" />
                        </view-section-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import { initCommonMetatag } from "@/store/metatags";

import ViewSectionCard from "@/components/console/dumb/view/view-section-card.vue";
import ViewSwitchSection from "@/components/console/dumb/view/view-switch-section.vue";
import FormTags from "./form/form-tags.vue";

export default {
    components: {
        ViewSectionCard,
        ViewSwitchSection,
        FormTags,
    },
    props: {
        value: { type: Object, default: initCommonMetatag },
        isClone: { type: Boolean, default: false },
    },
    data: () => ({
        form: initCommonMetatag(),

        shows: false,
        loading: false,
    }),
    computed: {
        ...mapGetters("metatags", ["variables_object"]),

        isCreate() {
            return !this.value?._id;
        },
        title() {
            let title = "메타태그";

            if (this.isCreate) return `${title} 생성`;
            if (this.isClone) return `${title} 복제`;
            return `${title} 수정`;
        },
    },
    methods: {
        ...mapActions("metatags", ["getVariables"]),
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                await this.getVariables();

                let { variables_object } = this;
                if (this.isCreate) {
                    this.form = initCommonMetatag.bind({ variables_object })();
                } else {
                    let { metatag } = await api.console.metatags.get({ _id: this.value?._id });
                    if (this.isClone) delete metatag._id;
                    this.form = initCommonMetatag.bind({ variables_object })(metatag);
                }
            } finally {
                this.loading = false;
            }
        },
        validates() {
            try {
                let { path } = this.form;

                if (!path) throw new Error("경로를 입력하세요");

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        async save() {
            // Vuetify 2 콤보박스(종류·key·value)는 칸 밖을 누르면 setTimeout 뒤에(click-outside) 입력 중인 글자를 값으로 확정한다. 확정된 뒤에 저장한다
            await new Promise((resolve) => setTimeout(resolve));

            if (!this.validates()) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { post, put } = api.console.metatags;
                let { ...form } = this.form;

                let { metatag } = await (this.isCreate || this.isClone ? post : put)(form);

                alert(this.isCreate || this.isClone ? "생성되었습니다" : "수정되었습니다");
                this.$emit("input", metatag);
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },
        emit() {
            let { variables_object } = this;
            this.form = initCommonMetatag.bind({ variables_object })(this.form);
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
.metatag-form {
    &__code ::v-deep textarea {
        font-size: 0.75rem !important;
        line-height: 1.425;
        font-family: monospace, monospace;
        max-height: 560px;
        overflow-y: auto !important;
    }
}
</style>
